import React, { useContext, useReducer, createContext } from 'react'
import reducer, { defaultInitialState, stepsMap } from './FamilyReviewReducer'

export const STEPS = stepsMap

export const FamilyReviewStateContext = createContext(null)
export const FamilyReviewDispatchContext = createContext(null)

export default function FamilyReviewContextProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, defaultInitialState)

  return (
    <FamilyReviewStateContext.Provider value={state}>
      <FamilyReviewDispatchContext.Provider value={dispatch}>{children}</FamilyReviewDispatchContext.Provider>
    </FamilyReviewStateContext.Provider>
  )
}

export const useFamilyReviewStateContext = () => {
  const context = useContext(FamilyReviewStateContext)
  if (!context) {
    throw new Error(
      'useFamilyReviewStateContext must be used within a FamilyReviewContextProvider. If writing a test, use <StateProvider> from testUtils.js'
    )
  }
  return context
}
export const useFamilyReviewDispatchContext = () => {
  const context = useContext(FamilyReviewDispatchContext)
  if (!context) {
    throw new Error(
      'useFamilyReviewDispatchContext must be used within a FamilyReviewContextProvider. If writing a test, use <StateProvider> from testUtils.js'
    )
  }
  return context
}
